import { render } from "./InternshipStatus.vue?vue&type=template&id=c1bdb9c2&ts=true"
import script from "./InternshipStatus.vue?vue&type=script&lang=ts"
export * from "./InternshipStatus.vue?vue&type=script&lang=ts"

import "./InternshipStatus.vue?vue&type=style&index=0&id=c1bdb9c2&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__